export * from './BookOpenIcon';
export * from './BookOpenIcon16Light';
export * from './BookOpenIcon16Regular';
export * from './BookOpenIcon16Solid';
export * from './BookOpenIcon20Light';
export * from './BookOpenIcon20Regular';
export * from './BookOpenIcon20Solid';
export * from './BookOpenIcon24Regular';
export * from './BookOpenIcon24Solid';
export * from './BookOpenIcon32Regular';
export * from './BookOpenIcon64Regular';
